import { render, staticRenderFns } from "./ModalCompanies.vue?vue&type=template&id=3d90ffc3&scoped=true&lang=pug&"
import script from "./ModalCompanies.vue?vue&type=script&lang=js&"
export * from "./ModalCompanies.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompanies.vue?vue&type=style&index=0&id=3d90ffc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90ffc3",
  null
  
)

export default component.exports